import { ReactComponent as SvgBr } from './BR.svg.es.js';
import { ReactComponent as SvgEu } from './EU.svg.es.js';
import { ReactComponent as SvgMxn } from './MXN.svg.es.js';
import { ReactComponent as SvgSgp } from './SGP.svg.es.js';
import { ReactComponent as SvgUsa } from './USA.svg.es.js';

const SvgFlagIcons = {
    BR: SvgBr,
    EU: SvgEu,
    USA: SvgUsa,
    MXN: SvgMxn,
    SGP: SvgSgp
};

export { SvgFlagIcons };
//# sourceMappingURL=index.es.js.map
